var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-major-cat", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-section-title" }, [_vm._v("专业分类")]),
    _vm._v(" "),
    _c("div", { staticClass: "mobile-major-cat__box" }, [
      _c(
        "div",
        {
          staticClass: "mobile-major-cat__scroll",
          on: { touchstart: _vm.onTouchStart, touchend: _vm.onTouchEnd },
        },
        [
          _c(
            "div",
            {
              staticClass: "mobile-major-cat__pages",
              style: {
                transform: "translateX(-" + _vm.currentPage * 100 + "%)",
              },
            },
            _vm._l(_vm.pagedData, function (page, pi) {
              return _c(
                "div",
                { key: pi, staticClass: "mobile-major-cat__page" },
                [
                  _c(
                    "div",
                    { staticClass: "mobile-major-cat__grid" },
                    _vm._l(page, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.id || pi * 8 + index,
                          staticClass: "mobile-major-cat__item",
                          on: {
                            click: function ($event) {
                              return _vm.handleClick(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "mobile-major-cat__icon-wrap" },
                            [
                              _c("img", {
                                staticClass: "mobile-major-cat__icon",
                                attrs: {
                                  src: _vm.getIcon(
                                    item.tindex != null
                                      ? item.tindex
                                      : pi * 8 + index
                                  ),
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mobile-major-cat__name" }, [
                            _vm._v(_vm._s(item.majorName || item.name)),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _vm.pageCount > 1
        ? _c(
            "div",
            { staticClass: "mobile-major-cat__dots" },
            _vm._l(_vm.pageCount, function (n) {
              return _c("span", {
                key: n,
                staticClass: "mobile-major-cat__dot",
                class: { "is-active": n - 1 === _vm.currentPage },
              })
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }